// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ruwNu","loadingWrap":"styles_loadingWrap__qt2NB","noData":"styles_noData__DaEBh","noDataIcon":"styles_noDataIcon__JKUFm"};